@if (ad(); as ad) {
  @if (ad.status === statuses.Pending) {
    <div class="my-2 px-2 border border-1 border-primary rounded">
      <span class="badge text-bg-warning my-2">{{ 'PENDING' | translate }}</span>
      <span>
        {{ 'CAR_IN_PENDING' | translate }}
      </span>
    </div>
  }
  <div class="row py-2">
    <div class="col-md-12 col-lg-6">
      <p><i class="bi bi-clock-fill px-1"></i>{{ ad.createdAt | date: 'dd.MM.yyyy' }}</p>
      <p>
        {{ 'CAR_DETAILS_CONTACT' | translate }}:
        <strong class="cursor-poiner phone-number-text" (click)="openWhatsApp(ad.contactNumber)"
          >{{ ad.contactNumber }} <i class="bi bi-whatsapp text-success fs-4"></i
        ></strong>
      </p>
      <span class="py-2">{{ 'CAR_DETAILS_DESCRIPTION' | translate }}:</span>
      <p class="text-pre-line">
        <strong>{{ ad.description }}</strong>
      </p>
    </div>
    <div class="col-md-12 col-lg-6">
      <p>
        {{ 'CAR_DETAILS_SELLER' | translate }}:
        <strong
          ><a routerLink="/users/{{ ad.user.id }}">{{ ad.user.name }}</a></strong
        >

        @if (
          (ad.user.plan === plans.Pro ||
            ad.user.plan === plans.Unlimited ||
            ad.user.plan === plans.Flex) &&
          ad.user.isPlanActive
        ) {
          <app-plan-type [plan]="ad.user.plan"></app-plan-type>
        }
      </p>

      @if (ad.user.officePhotoUrl && ad.user.isPlanActive) {
        <p>
          <img
            loading="lazy"
            [src]="ad.user.officePhotoUrl"
            alt="Dealer image"
            class="img-thumbnail thumbnail-image"
          />
        </p>
      }
    </div>
  </div>
}
